var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useLayoutEffect, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "@mui/material";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
export var useScreenSize = function () {
    var theme = useTheme();
    var _a = __read(useState(false), 2), isClient = _a[0], setIsClient = _a[1];
    var isMobile = useMediaQuery({
        maxWidth: theme.breakpoints.values.sm - 0.05,
    });
    var isMedium = useMediaQuery({
        minWidth: theme.breakpoints.values.md,
    });
    var isLarge = useMediaQuery({
        minWidth: theme.breakpoints.values.lg,
    });
    useIsomorphicLayoutEffect(function () {
        if (typeof window !== "undefined")
            setIsClient(true);
    }, []);
    return {
        isMedium: isClient ? isMedium : false,
        isMobile: isClient ? isMobile : true,
        isLarge: isClient ? isLarge : false,
    };
};
